import type { ExistingOrder } from '@einwert/valuation-api-client'
import { tokens, WhiteEmptyStateImage } from 'ComponentLibrary'
import { Typography } from 'ComponentLibrary/src/piazza'
import { Box, Stack } from '@mui/material'
import { NavLink } from 'ComponentLibrary/src/piazza/text/Link/Link'
import { useTranslation } from 'react-i18next'

type NoValuationInfoProps = {
    latestOrder?: ExistingOrder
}

export const NoValuationInfo = ({ latestOrder }: NoValuationInfoProps) => {
    const { t: tAssetKeyValues } = useTranslation('pages', { keyPrefix: 'assets.assetDetails.assetKeyValues.noValuationInfo' })

    return (
        <Stack
            direction="column"
            gap={tokens.SizingSpacing200}
            padding={tokens.SizingSpacing300}
            border={`1px solid ${tokens.ColorBorderDefault}`}
            borderRadius={tokens.SizingCornerL}
            alignItems="center"
        >
            <WhiteEmptyStateImage height="120px" width="145px" />
            <Typography variant="textS" color={tokens.ColorTextDefault}>
                {tAssetKeyValues('description')}
            </Typography>
            <Box>
                {latestOrder ? (
                    <NavLink href={`/orders/${latestOrder.uuid}/overview`} label={tAssetKeyValues('viewOrder')} />
                ) : (
                    <NavLink href="/orders/new" label={tAssetKeyValues('createOrder')} />
                )}
            </Box>
        </Stack>
    )
}
